
import { defineComponent, ref, watchEffect, computed } from "vue";
import { Field, ErrorMessage } from "vee-validate";
import { useStore } from "vuex";
import Editor from "@tinymce/tinymce-vue";
import DropDownSection from "@/components/sections/DropDownSections.vue";

interface IStep2 {
  willAccessFromRecord: string;
  accessType: string;
  accessTypeOther: string;
}

export default defineComponent({
  name: "step-2",
  components: {
    Field,
    ErrorMessage,
    Editor,
    DropDownSection,
  },
  setup() {
    const store = useStore();
    const listDropDownSections = [
      {
        title: "Information",
        descriptions: [{ description: " Some Information" }],
      },
    ];
    const step2 = ref<IStep2>({
      willAccessFromRecord: "0",
      accessType: "",
      accessTypeOther: "",
    });

    const currentEditorToken = computed(() => {
      return store.getters.currentEditorToken;
    });

    watchEffect(() => {
      const data = store.getters.currentRecruitment;
      if (data === null || data.data === undefined) return;
      step2.value.willAccessFromRecord = data.data.willAccessFromRecord
        ? "1"
        : "0";
      step2.value.accessType = data.data?.accessType || "";
      step2.value.accessTypeOther =
        data.data.accessTypeOther != null &&
        data.data.accessTypeOther != undefined
          ? data.data.accessTypeOther
          : "";
    });

    return {
      step2,
      Editor,
      listDropDownSections,
      currentEditorToken,
    };
  },
});
